"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocPaymentGroupsNow = void 0;
const typeorm_1 = require("typeorm/browser");
let DocPaymentGroupsNow = class DocPaymentGroupsNow {
};
__decorate([
    (0, typeorm_1.ViewColumn)({ name: 'doc_portion_on_payment' }),
    __metadata("design:type", Number)
], DocPaymentGroupsNow.prototype, "docPortionOnPayment", void 0);
__decorate([
    (0, typeorm_1.ViewColumn)({ name: 'delta' }),
    __metadata("design:type", Number)
], DocPaymentGroupsNow.prototype, "delta", void 0);
__decorate([
    (0, typeorm_1.ViewColumn)({ name: 'grouped_line_items_total_gross' }),
    __metadata("design:type", Number)
], DocPaymentGroupsNow.prototype, "groupedLineItemsTotalGross", void 0);
__decorate([
    (0, typeorm_1.ViewColumn)({ name: 'grouplinked_payments_totals' }),
    __metadata("design:type", Number)
], DocPaymentGroupsNow.prototype, "grouplinkPaymentsTotals", void 0);
__decorate([
    (0, typeorm_1.ViewColumn)({ name: 'doc_net_total' }),
    __metadata("design:type", Number)
], DocPaymentGroupsNow.prototype, "docNetTotal", void 0);
__decorate([
    (0, typeorm_1.ViewColumn)({ name: 'doc_gross_total' }),
    __metadata("design:type", Number)
], DocPaymentGroupsNow.prototype, "docGrossTotal", void 0);
__decorate([
    (0, typeorm_1.ViewColumn)({ name: 'doc_id' }),
    __metadata("design:type", String)
], DocPaymentGroupsNow.prototype, "docId", void 0);
__decorate([
    (0, typeorm_1.ViewColumn)({ name: 'number' }),
    __metadata("design:type", String)
], DocPaymentGroupsNow.prototype, "number", void 0);
__decorate([
    (0, typeorm_1.ViewColumn)({ name: 'issue_date' }),
    __metadata("design:type", Date)
], DocPaymentGroupsNow.prototype, "issueDate", void 0);
__decorate([
    (0, typeorm_1.ViewColumn)({ name: 'doc_type' }),
    __metadata("design:type", String)
], DocPaymentGroupsNow.prototype, "docType", void 0);
__decorate([
    (0, typeorm_1.ViewColumn)({ name: 'due_date' }),
    __metadata("design:type", Date)
], DocPaymentGroupsNow.prototype, "dueDate", void 0);
__decorate([
    (0, typeorm_1.ViewColumn)({ name: 'database_set_doc_status' }),
    __metadata("design:type", String)
], DocPaymentGroupsNow.prototype, "databaseSetDocStatus", void 0);
__decorate([
    (0, typeorm_1.ViewColumn)({ name: 'account_name' }),
    __metadata("design:type", String)
], DocPaymentGroupsNow.prototype, "accountName", void 0);
__decorate([
    (0, typeorm_1.ViewColumn)({ name: 'account_firstname' }),
    __metadata("design:type", String)
], DocPaymentGroupsNow.prototype, "accountFirstname", void 0);
__decorate([
    (0, typeorm_1.ViewColumn)({ name: 'account_lastname' }),
    __metadata("design:type", String)
], DocPaymentGroupsNow.prototype, "accountLastname", void 0);
__decorate([
    (0, typeorm_1.ViewColumn)({ name: 'account_billing_street' }),
    __metadata("design:type", String)
], DocPaymentGroupsNow.prototype, "accountBillingStreet", void 0);
__decorate([
    (0, typeorm_1.ViewColumn)({ name: 'account_billing_postal_code' }),
    __metadata("design:type", String)
], DocPaymentGroupsNow.prototype, "accountBillingPostalCode", void 0);
__decorate([
    (0, typeorm_1.ViewColumn)({ name: 'account_billing_city' }),
    __metadata("design:type", String)
], DocPaymentGroupsNow.prototype, "accountBillingCity", void 0);
__decorate([
    (0, typeorm_1.ViewColumn)({ name: 'account_billing_country' }),
    __metadata("design:type", String)
], DocPaymentGroupsNow.prototype, "accountBillingCountry", void 0);
__decorate([
    (0, typeorm_1.ViewColumn)({ name: 'account_shipping_street' }),
    __metadata("design:type", String)
], DocPaymentGroupsNow.prototype, "accountShippingStreet", void 0);
__decorate([
    (0, typeorm_1.ViewColumn)({ name: 'account_shipping_postal_code' }),
    __metadata("design:type", String)
], DocPaymentGroupsNow.prototype, "accountShippingPostalCode", void 0);
__decorate([
    (0, typeorm_1.ViewColumn)({ name: 'account_shipping_city' }),
    __metadata("design:type", String)
], DocPaymentGroupsNow.prototype, "accountShippingCity", void 0);
__decorate([
    (0, typeorm_1.ViewColumn)({ name: 'account_shipping_country' }),
    __metadata("design:type", String)
], DocPaymentGroupsNow.prototype, "accountShippingCountry", void 0);
__decorate([
    (0, typeorm_1.ViewColumn)({ name: 'account_email_for_invoices' }),
    __metadata("design:type", String)
], DocPaymentGroupsNow.prototype, "accountEmailForInvoices", void 0);
__decorate([
    (0, typeorm_1.ViewColumn)({ name: 'account_type' }),
    __metadata("design:type", String)
], DocPaymentGroupsNow.prototype, "accountType", void 0);
__decorate([
    (0, typeorm_1.ViewColumn)({ name: 'account_sfid' }),
    __metadata("design:type", String)
], DocPaymentGroupsNow.prototype, "accountSfid", void 0);
__decorate([
    (0, typeorm_1.ViewColumn)({ name: 'supposed_document_status' }),
    __metadata("design:type", String)
], DocPaymentGroupsNow.prototype, "supposedDocumentStatus", void 0);
__decorate([
    (0, typeorm_1.ViewColumn)({ name: 'doc_numbers' }),
    __metadata("design:type", String)
], DocPaymentGroupsNow.prototype, "docNumbers", void 0);
__decorate([
    (0, typeorm_1.ViewColumn)({ name: 'doc_issue_dates' }),
    __metadata("design:type", String)
], DocPaymentGroupsNow.prototype, "docIssueDates", void 0);
__decorate([
    (0, typeorm_1.ViewColumn)({ name: 'doc_lineitems_deliverydates' }),
    __metadata("design:type", String)
], DocPaymentGroupsNow.prototype, "docLineitemsDeliverydates", void 0);
__decorate([
    (0, typeorm_1.ViewColumn)({ name: 'doc_count' }),
    __metadata("design:type", Number)
], DocPaymentGroupsNow.prototype, "docCount", void 0);
DocPaymentGroupsNow = __decorate([
    (0, typeorm_1.ViewEntity)({
        name: 'doc_payment_groups_now',
        schema: 'analytics',
        materialized: true,
        expression: `
    SELECT
      CASE
        WHEN grouped_line_items_total_gross IS NOT NULL AND ABS(grouped_line_items_total_gross) > 0
        THEN (doc_gross_total / grouped_line_items_total_gross) * grouplinked_payments_totals
        ELSE NULL
      END AS doc_portion_on_payment,
      *
    FROM (
      SELECT
        (
          (
            CASE
              WHEN grouplinked_line_item_total_gross->'volume'::text = 'null'
                THEN 0.0::decimal
              ELSE (grouplinked_line_item_total_gross->'volume')::numeric
            END
          ) - grouplinked_payments_totals::numeric
        ) AS delta,
        (
          CASE
            WHEN grouplinked_line_item_total_gross->'volume'::text = 'null'
              THEN 0.0::decimal
            ELSE (grouplinked_line_item_total_gross->'volume')::numeric
          END
        ) AS grouped_line_items_total_gross,
        grouplinked_payments_totals,
        doc_total_amount AS doc_net_total,
        (
          SELECT SUM(line_volume)
          FROM
          (
            SELECT
              CASE
                WHEN doc.type = 'credit_note' AND NOT doc.reverse_vat_charge
                  THEN (-li.total_price*(100+li.vat_rate)/100)::numeric
                WHEN doc.type = 'credit_note' AND doc.reverse_vat_charge
                  THEN (-li.total_price*(100)/100)::numeric
                WHEN doc.type = 'invoice' AND NOT doc.reverse_vat_charge
                  THEN (li.total_price*(100+li.vat_rate)/100)::numeric
                WHEN doc.type = 'invoice' AND doc.reverse_vat_charge
                  THEN (li.total_price*(100)/100)::numeric
                ELSE 0.0
              END AS line_volume,
                 doc.number AS doc_number
               FROM accounting.accounting_document doc
               LEFT JOIN accounting.accounting_document_line_item li ON li.document_id = doc.id
               WHERE TRUE AND li.document_id = doc_id AND doc.id = doc_id
              ) AS this_doc_gross_line_items
        ) AS doc_gross_total,
        doc_id,
        number,
        issue_date,
        doc_type,
        (issue_date + INTERVAL '1 day' * COALESCE(due_days, 14)) AS due_date,
        database_set_doc_status,
        account_name,
        account_firstname,
        account_lastname,
        account_billing_street,
        account_billing_postal_code,
        account_billing_city,
        account_billing_country,
        account_shipping_street,
        account_shipping_postal_code,
        account_shipping_city,
        account_shipping_country,
        account_email_for_invoices,
        account_type,
        account_sfid,
        CASE
          WHEN (
            ABS((
              CASE
                WHEN grouplinked_line_item_total_gross->'volume'::text = 'null'
                  THEN 0.0::decimal
                ELSE (grouplinked_line_item_total_gross->'volume')::numeric
              END
            )) <= (
              ABS(grouplinked_payments_totals)+0.05
            ) OR
            grouplinked_line_item_total_gross->'volume'::text = 'null'
          )
            THEN 'paid'
          WHEN ABS((
            CASE
              WHEN grouplinked_line_item_total_gross->'volume'::text = 'null'
                THEN 0.0::decimal
              ELSE (grouplinked_line_item_total_gross->'volume')::numeric
            END
          )) > (ABS(grouplinked_payments_totals)+0.05) OR
          grouplinked_payments_totals IS NULL
            THEN 'unpaid'
          ELSE 'unknown'
        END AS supposed_document_status,
        grouplinked_line_item_total_gross->>'doc_numbers' AS doc_numbers,
        grouplinked_line_item_total_gross->>'issue_dates' AS doc_issue_dates,
        grouplinked_line_item_total_gross->>'delivery_dates' AS doc_lineitems_deliverydates,
        JSONB_ARRAY_LENGTH((grouplinked_line_item_total_gross->>'doc_numbers')::jsonb) AS doc_count
      FROM (
          select
          (
              select

              jsonb_build_object(
                'volume', sum(line_volume),
                'doc_numbers', jsonb_agg(DISTINCT doc_number),
                'issue_dates', jsonb_agg(issue_date),
                'delivery_dates', jsonb_agg(delivery_date)
              ) as doc
              from
              (
                  select
                  case
                      when doc.type = 'credit_note' and not doc.reverse_vat_charge then (-li.total_price*(100+li.vat_rate)/100)::numeric
                      when doc.type = 'credit_note' and doc.reverse_vat_charge     then (-li.total_price*(100)/100)::numeric
                      when doc.type = 'invoice' and not doc.reverse_vat_charge     then (li.total_price*(100+li.vat_rate)/100)::numeric
                      when doc.type = 'invoice' and doc.reverse_vat_charge         then (li.total_price*(100)/100)::numeric
                      else 0.0
                  end  as line_volume,
                  doc.number as doc_number,
                  doc.issue_date as issue_date,
                  li.delivery_date as delivery_date

                  from accounting.accounting_document doc
                  left join accounting.accounting_document_line_item li
                      on li.document_id = doc.id
                  where
                  true
                  and doc.status not in ('cancelled', 'cancellation_sent')
                  and doc.issue_date <= NOW()::date
                  and (
                      doc.id in  (
                        with recursive docpr as (
                          select
                            accounting_document_id,
                            payment_record_id
                            ,
                            jsonb_build_object('accounting_document_id', accounting_document_id, 'payment_record_id', payment_record_id ) as docprjson

                          from accounting.accounting_document_payments_payment_record -- adppr
                          where accounting_document_id = doc_id
                          union
                          select
                            adppr.accounting_document_id,
                            adppr.payment_record_id
                            ,
                            jsonb_build_object('accounting_document_id', adppr.accounting_document_id, 'payment_record_id', adppr.payment_record_id ) as docprjson
                          from accounting.accounting_document_payments_payment_record adppr
                              join docpr on
                          (	docpr.accounting_document_id = adppr.accounting_document_id
                            or
                            docpr.payment_record_id = adppr.payment_record_id
                          )
                        )
                        select
                              accounting_document_id
                        from docpr
                        union
                        select doc_id
                      )
                      -- or doc.id = doc_id
                  )
                  order by doc_number asc
              ) as line_volumes
          ) as grouplinked_line_item_total_gross,

          (
              select
              -- sum(line_volume)
              *
              from
              (
                  select sum(pr.total) from
                  payment.payment_record pr
                  where pr.id in
                  (
                    with recursive docpr as (
                      select
                        accounting_document_id,
                        payment_record_id
                        ,
                        jsonb_build_object('accounting_document_id', accounting_document_id, 'payment_record_id', payment_record_id ) as docprjson

                      from accounting.accounting_document_payments_payment_record -- adppr
                      where accounting_document_id = doc_id
                      union
                      select
                        adppr.accounting_document_id,
                        adppr.payment_record_id
                        ,
                        jsonb_build_object('accounting_document_id', adppr.accounting_document_id, 'payment_record_id', adppr.payment_record_id ) as docprjson
                      from accounting.accounting_document_payments_payment_record adppr
                      join docpr on
                      (	docpr.accounting_document_id = adppr.accounting_document_id
                        or
                        docpr.payment_record_id = adppr.payment_record_id
                      )
                    )
                    select
                      payment_record_id
                    from docpr
                  )
                and pr.date <= NOW()::date
                ) as line_volumes
          ) as grouplinked_payments_totals,
          *

      from
      (
          select

            doc_outer.id as doc_id,
            doc_outer.total_amount as doc_total_amount,
            doc_outer.number,
            doc_outer.issue_date,
            doc_outer.due_days,
            doc_outer.type as doc_type,
            doc_outer.status as database_set_doc_status,
            acc.name as account_name,
            acc.firstname as account_firstname,
            acc.lastname as account_lastname,
            acc.billingstreet as account_billing_street,
            acc.billingpostalcode as account_billing_postal_code,
            acc.billingcity as account_billing_city,
            acc.billingcountry as account_billing_country,
            acc.shippingstreet as account_shipping_street,
            acc.shippingpostalcode as account_shipping_postal_code,
            acc.shippingcity as account_shipping_city,
            acc.shippingcountry as account_shipping_country,
            acc.emailforinvoices__c as account_email_for_invoices,
            acc.role as account_type,
            acc.id as account_sfid
          from accounting.accounting_document doc_outer
          left join public.account acc on doc_outer.target_id = acc.id
          where true
          -- and doc_outer.number = 'RN-2022000722'
          and doc_outer.issue_date <= NOW()::date
          -- and doc_outer.issue_date >= '2022-12-25'::date
          and doc_outer.status not in ('cancelled', 'cancellation_sent')
      ) as doc_payment

      ) AS group_data
    ) AS alldocbased
  `,
    })
], DocPaymentGroupsNow);
exports.DocPaymentGroupsNow = DocPaymentGroupsNow;
//# sourceMappingURL=materialized-doc-payment-groups-now.js.map